import { Home } from '@mui/icons-material';
import React, { forwardRef } from 'react';

export const AssetsIcon = forwardRef<SVGSVGElement, React.ComponentProps<typeof Home>>((properties, reference) => {
  return <Home ref={reference} {...properties} />;
});

AssetsIcon.displayName = 'AssetsIcon';
